<template>
    <div class="connection-status mt-1">
        <template v-if="!isPending">
            <span class="mr-2">{{ statusText }}</span>
            <span class="status-indicator" :class="statusClasses"></span>
        </template>
        <template v-else>
            <span class="mr-2">Connecting...</span>
            <span class="status-indicator unknown"></span>
        </template>
    </div>
</template>
<script>
import { ConnectionStatus as ConnectionStatusEnum } from '../../utils/integration-helpers'

export default {
    name: 'ConnectionStatus',
    props: {
        connectionStatus: {
            type: Number,
            required: true,
        },
        isPending: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statusText() {
            if (this.connectionStatus === ConnectionStatusEnum.CONNECTED) {
                return 'Connected'
            }
            if (this.connectionStatus === ConnectionStatusEnum.FAILED) {
                return 'Disconnected'
            }

            return 'Unknown'
        },
        statusClasses() {
            return {
                'connected': this.connectionStatus === ConnectionStatusEnum.CONNECTED,
                'disconnected': this.connectionStatus === ConnectionStatusEnum.FAILED,
                'unknown': this.connectionStatus === ConnectionStatusEnum.UNKNOWN
            }
        }
    }
}
</script>
<style scoped>
.connection-status {
    display: flex;
    align-items: center;
    font-size: 16px;
}

.status-indicator {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    display: inline-block;
}

.status-indicator.connected {
    background-color: #00a344;
}

.status-indicator.disconnected {
    background-color: #d70101;
}

.status-indicator.unknown {
    background-color: #4f4e4c;
}
</style>
